import { createSelector } from '@ngrx/store';
import { getDragonflyRedeemRulesState } from '../reducers';

export const getRedeemRulesSearchState = createSelector(getDragonflyRedeemRulesState, (state) => state?.search);

export const getSchemas = createSelector(getRedeemRulesSearchState, (state) => state?.schemas);

export const getSelectedSchema = createSelector(getRedeemRulesSearchState, (state) => state?.selectedSchema);

export const getPanelExpanded = createSelector(getRedeemRulesSearchState, (state) => state?.panelExpanded);

export const getLastSearchResponse = createSelector(getRedeemRulesSearchState, (state) => state?.lastSearchResponse);
